import api from "../../../utils/api";

export const createCiRelationType = async (payload) => {
  if (process.env.NODE_ENV === "development") console.log(payload);
  const res = await api.post("/ci_relation_types/", payload);
  return res.data;
};

export const readCiRelationType = async (publicId) => {
  if (!publicId) throw new Error("Missing or invalid ID for CI relation type");
  const res = await api.get(`/ci_relation_types/${publicId}`);
  return res.data;
};

export const readCiRelationTypes = async () => {
  const res = await api.get("/ci_relation_types");
  return res.data;
};

export const updateCiRelationType = async (payload) => {
  if (process.env.NODE_ENV === "development") console.log(payload);
  if (!payload.public_id) throw new Error("Missing or invalid ID for CI relation type");
  const res = await api.put(`/ci_relation_types/${payload.public_id}`, payload);
  return res.data;
};

export const deleteCiRelationType = async (publicId) => {
  if (process.env.NODE_ENV === "development") console.log(publicId);
  if (!publicId) throw new Error("Invalid ID for CI relation type!");
  return await api.delete(`/ci_relation_types/${publicId}`);
};
